/**
 * @prettier
 */
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';

export function PideDirectoStepperIcon(): React.ReactElement {
    const classes = useStyles();

    return (
        <svg className={classes.icon} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='16' cy='16' r='15' stroke='#1B5764' strokeWidth='2' />
            <circle cx='16' cy='16' r='12' fill='#1B5764' />
            <path
                d='M9.3335 9.33911C9.39655 9.33337 9.43095 9.33337 9.47107 9.33337C10.3768 9.33337 11.2825 9.33337 12.1882 9.33337C12.2684 9.33337 12.32 9.3563 12.3716 9.41936C13.5869 10.841 14.8078 12.2683 16.0288 13.6899C16.0804 13.7472 16.0861 13.7874 16.0288 13.8504C15.0371 15.0084 14.0454 16.1663 13.0538 17.3242C12.8187 17.5994 12.5894 17.8688 12.3544 18.1382C12.3258 18.1726 12.2684 18.207 12.2226 18.207C11.2882 18.2127 10.3538 18.2127 9.41375 18.207C9.39082 18.207 9.37362 18.2012 9.3335 18.1955C10.6003 16.7108 11.8614 15.2434 13.1225 13.7644C11.8672 12.3027 10.6118 10.8295 9.3335 9.33911Z'
                fill='#63D6B3'
            />
            <path
                d='M21.7605 13.8219C21.2102 14.4696 20.6542 15.1174 20.1039 15.7651C19.5364 16.4301 18.9689 17.0893 18.4014 17.7542C18.2695 17.909 18.1377 18.0638 17.9944 18.23C19.2555 19.7032 20.5166 21.1764 21.7834 22.6554C21.749 22.6611 21.7261 22.6668 21.7032 22.6668C20.7745 22.6668 19.8402 22.6668 18.9115 22.6668C18.8714 22.6668 18.8141 22.6439 18.7854 22.6152C17.5415 21.165 16.2976 19.7147 15.0537 18.2644C15.048 18.2587 15.0422 18.2472 15.0308 18.23C15.2429 17.9778 15.4607 17.7256 15.6785 17.4734C16.4925 16.5218 17.3122 15.5645 18.1319 14.6129C18.3498 14.3607 18.5619 14.1085 18.7797 13.8563C18.8083 13.8219 18.8599 13.7932 18.9001 13.7932C19.8516 13.7932 20.8089 13.7932 21.7605 13.7932C21.7605 13.7932 21.7605 13.8047 21.7605 13.8219Z'
                fill='#63D6B3'
            />
        </svg>
    );
}

const useStyles = makeStyles((theme) => ({
    icon: {
        position: 'relative',
        right: '3px',
        animation: '$grow 1s infinite ease-in-out',
    },
    '@keyframes grow': {
        '0%': {
            transform: 'scale(1)',
        },
        '50%': {
            transform: 'scale(1.3)',
        },
        '100%': {
            transform: 'scale(1)',
        },
    },
}));
